<template>
    <div class="field is-horizontal is-mobile" style="padding-top: 10px;">
        <bid-update :bid="bid"></bid-update>
        <bid-cancel :bid="bid"></bid-cancel>
        <bid-status v-if="userRole === 'Admin'" :bid="bid"></bid-status>
        <bid-result v-if="userRole === 'Admin'" :bid="bid"></bid-result>
        <div class="field" style="padding-right: 15px;">
            <router-link :to="'/single/' + bid.lot.lot_id" class="button" target="_blank">Full info</router-link>
        </div>
    </div>
</template>

<script>
    import bidUpdate from './BidUpdate.vue'
    import bidCancel from './BidCancel.vue'
    import bidStatus from './BidStatus.vue'
    import bidResult from './BidResult.vue'
    import apiAuth from '../../../../api/apiAuth'
    export default {
        components: {
            bidUpdate: bidUpdate,
            bidCancel: bidCancel,
            bidStatus: bidStatus,
            bidResult: bidResult
        },
        props: ['bid'],
        data () {
            return {
                userRole: ''
            }
        },
        mounted () {
            this.userRole = this.$store.getters.getUserRole
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Card/Buttons/Bids/BidButtons.vue